import { render } from "./ASGoTop.vue?vue&type=template&id=7130bc2c"
import script from "./ASGoTop.vue?vue&type=script&lang=js"
export * from "./ASGoTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__